const _ = require('lodash')

let mapper_options = {
  afterCreate (props, options, result) {
    return _.merge({}, result, props.digital_asset)
  },
  endpoint: 'digital_assets',
  recordClass: require('./record'),
  relations: {
    belongsTo: {
      brand: {
        foreignKey: 'brand_id',
        localField: 'brand'
      }
    },
    hasMany: {
      campaign: {
        localKeys: 'campaign_ids',
        localField: 'campaigns'
      },
      share_setting: {
        localKeys: 'share_settings_ids',
        localField: 'share_settings'
      }
    },
    hasOne: {
      asset: {
        foreignKey: 'asset_id',
        localField: 'asset'
      }
    }
  }
}

module.exports = (store) => {
  store.defineMapper('digital_asset', mapper_options)
}
